import React, { Fragment } from 'react';
import { Text, View } from '@react-pdf/renderer';
import intl from 'react-intl-universal';
import { styles } from './styles';
import PropTypes from 'prop-types';
import logger from 'utils/logger';
import { KEY_LABELS, getValueFromLabel, LABELS } from './constants';
import localData from 'utils/localData';
import { USER_DATA } from 'shared/constants/users';

const log = logger.createLogger('ReportInfo');

const propTypes = {
  reportContent: PropTypes.object.isRequired,
};

const ReportInfo = ({ reportContent }) => {
  const { content } = reportContent;
  const locale = localData.get(USER_DATA.PREFFERED_LANGUAGE);
  return (
    <Fragment>
      <View style={styles.reportInfoTable}>
        <View style={styles.reportInfoRow}>
          <Text style={styles.reportInfoKey}>
            {intl.get(KEY_LABELS[LABELS.ISSUE_TITLE])}
          </Text>
          <Text style={styles.reportInfoValue}>
            {getValueFromLabel(content, KEY_LABELS[LABELS.ISSUE_TITLE])}
          </Text>
          <Text style={styles.reportInfoKey}>
            {intl.get(KEY_LABELS[LABELS.ISSUE_DATE])}
          </Text>
          <Text style={styles.reportInfoValue}>
            {new Date(
              getValueFromLabel(content, KEY_LABELS[LABELS.ISSUE_DATE])
            ).toLocaleDateString(locale, {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })}
          </Text>
        </View>
        <View style={styles.reportInfoRow}>
          <Text style={styles.reportInfoKey}>
            {intl.get(KEY_LABELS[LABELS.PATIENT_NAME])}
          </Text>
          <Text style={styles.reportInfoValue}>
            {getValueFromLabel(content, KEY_LABELS[LABELS.PATIENT_NAME])}
          </Text>
          <Text style={styles.reportInfoKey}>
            {intl.get(KEY_LABELS[LABELS.SRC_ORG_NAME])}
          </Text>
          <Text style={styles.reportInfoValue}>
            {getValueFromLabel(content, KEY_LABELS[LABELS.SRC_ORG_NAME])}
          </Text>
        </View>
        <View style={styles.reportInfoRow}>
          <Text style={styles.reportInfoKey}>
            {intl.get(KEY_LABELS[LABELS.PATIENT_GENDER])}
          </Text>
          <Text style={styles.reportInfoValue}>
            {getValueFromLabel(content, KEY_LABELS[LABELS.PATIENT_GENDER])}
          </Text>
          <Text style={styles.reportInfoKey}>
            {intl.get(KEY_LABELS[LABELS.DEPARTMENT])}
          </Text>
          <Text style={styles.reportInfoValue}>
            {getValueFromLabel(content, KEY_LABELS[LABELS.DEPARTMENT])}
          </Text>
        </View>
        <View style={styles.reportInfoRow}>
          <Text style={styles.reportInfoKey}>
            {intl.get(KEY_LABELS[LABELS.PATIENT_BIRTHDAY_DATE])}
          </Text>
          <Text style={styles.reportInfoValue}>
            {new Date(
              getValueFromLabel(
                content,
                KEY_LABELS[LABELS.PATIENT_BIRTHDAY_DATE]
              )
            ).toLocaleDateString(locale, {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })}
          </Text>
          <Text style={styles.reportInfoKey}>
            {intl.get(KEY_LABELS[LABELS.DOCTORS_FROM_SRC_ORG])}
          </Text>
          <Text style={styles.reportInfoValue}>
            {getValueFromLabel(
              content,
              KEY_LABELS[LABELS.DOCTORS_FROM_SRC_ORG]
            )}
          </Text>
        </View>
        <View style={styles.reportInfoRow}>
          <Text style={styles.reportInfoKey}>
            {intl.get(KEY_LABELS[LABELS.TAGS])}
          </Text>
          <Text style={styles.reportInfoValue2}>
            {getValueFromLabel(content, KEY_LABELS[LABELS.TAGS])}
          </Text>
        </View>
      </View>
    </Fragment>
  );
};

ReportInfo.propTypes = propTypes;

export default ReportInfo;
